import type {
  ScreenShownEvent,
  ScreenTapExportEvent,
  ScreenExportFileDownloadEvent,
  ScreenFilterAppliedEvent,
  ScreenFilterProperties,
} from '../types';

export const getScreenShownEvent = (
  screen: string,
  merchantsCount = 0
): ScreenShownEvent => ({
  event: `${screen}_screen_shown`,
  properties: {
    merchantsCount,
  },
});

export const getScreenTapExportEvent = (
  screen: string
): ScreenTapExportEvent => ({ event: `${screen}_screen_tap_export` });

export const getScreenExportFileDownloadEvent = (
  screen: string,
  fileSize: number
): ScreenExportFileDownloadEvent => ({
  event: `${screen}_screen_export_file_download`,
  properties: { fileSize },
});

export const getScreenFilterAppliedEvent = (
  screen: string,
  filterProperties: ScreenFilterProperties
): ScreenFilterAppliedEvent => ({
  event: `${screen}_screen_filter_applied`,
  properties: filterProperties,
});
